// extracted by mini-css-extract-plugin
export default {"headerWrapper":"Header_headerWrapper__V9LA8"};